<template>
  <div>
    <!-- <header></header> -->
    <div class="header">
      <div class="head_warp">
        <div class="head_title">心理健康消防平台</div>
      </div>
    </div>
    <!-- conotent -->
    <div class="content">
      <div class="warp" style="height: calc(100vh - 140px)">
        <div class="back-head">
          <h3>找回密码</h3>
          <p>
            请选择您的用户角色并输入您的基本信息，验证身份后，方可重置密码。
          </p>
          <div>
            <!-- 基本信息验证 -->
            <el-form
              ref="form"
              :model="form"
              :rules="formRules"
              label-width="100px"
              v-if="!isNext"
            >
              <div class="radio_warp">
                <el-radio
                  v-model="form.roleId"
                  :label="1"
                  style="margin-right: 40px"
                  >人员</el-radio
                >
                <el-radio v-model="form.roleId" :label="2">老师</el-radio>
              </div>
              <el-form-item label="所在地区：" prop="province">
                <div class="area_list">
                  <el-select
                    v-model="form.province"
                    @change="provinceChange"
                    placeholder="请选择省份"
                  >
                    <el-option
                      v-for="item in provinceList"
                      :key="item.area_id"
                      :label="item.area_name"
                      :value="item.area_id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="form.city"
                    placeholder="请选择城市"
                    style="margin: 0 10px"
                    @change="cityChange"
                  >
                    <el-option
                      v-for="item in cityList"
                      :key="item.area_id"
                      :label="item.area_name"
                      :value="item.area_id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="form.county"
                    placeholder="请选择区县"
                    @change="countyChange"
                  >
                    <el-option
                      v-for="item in countyList"
                      :key="item.area_id"
                      :label="item.area_name"
                      :value="item.area_id"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="年级班级：" prop="school">
                <div class="class_warp">
                  <el-select
                    v-model="form.school"
                    placeholder="请选择学校"
                    @change="schoolChange"
                  >
                    <el-option
                      v-for="item in schoolList"
                      :key="item.school_id"
                      :label="item.school_name"
                      :value="item.school_id"
                    ></el-option>
                  </el-select>
                  <el-select
                    style="margin: 0 10px"
                    v-model="form.grade"
                    placeholder="请选择年级"
                    @change="gradeChange"
                    v-if="form.roleId == 1"
                  >
                    <el-option
                      v-for="item in gradeList"
                      :key="item.grade_id"
                      :label="item.grade_name"
                      :value="item.grade_id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="form.roleId == 1"
                    v-model="form.class"
                    placeholder="请选择班级"
                    @change="classChange"
                  >
                    <el-option
                      v-for="item in classList"
                      :key="item.class_id"
                      :label="item.class_name"
                      :value="item.class_id"
                    ></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="账号：" prop="login_name">
                <el-input
                  v-model="form.login_name"
                  placeholder="请输入账号"
                  style="width: 675px"
                ></el-input>
              </el-form-item>
              <el-form-item label="身份证号：" prop="id_card">
                <el-input
                  v-model="form.id_card"
                  placeholder="请输入身份证号"
                  style="width: 675px"
                ></el-input>
              </el-form-item>
            </el-form>
            <!-- 重置密码 -->
            <div class="rest_pwd" v-else>
              <div class="rest_title">重置密码</div>
              <el-form
                :model="ruleForm"
                status-icon
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
              >
                <el-form-item label="新密码" prop="pass">
                  <el-input
                    type="password"
                    style="width: 675px"
                    v-model="ruleForm.pass"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                  <el-input
                    type="password"
                    style="width: 675px"
                    v-model="ruleForm.checkPass"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="next">
            <el-button
              v-if="!isNext"
              type="primary"
              @click="next"
              class="next_btn"
              >下一步</el-button
            >
            <el-button v-else type="primary" @click="submit" class="next_btn"
              >提交</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="footer_line"></div>
    <!--footer-->
    <div class="footer">
      <p>
        <a target="_bank" href="http://www.beian.miit.gov.cn"
          >蜀ICP备20012822号-4</a
        >
      </p>
      <p>
        <a href="http://www.bluerhyme.net/" target="_bank"
          >四川蓝韵心理咨询服务有限公司</a
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      provinceList: [],
      cityList: [],
      countyList: [],
      schoolList: [],
      gradeList: [],
      classList: [],
      isNext: false,
      form: {
        roleId: 1,
        province: "",
        city: "",
        county: "",
        login_name: "",
        school: "",
        grade: "",
        class: "",
        id_card: "",
      },
      ruleForm: {
        pass: "",
        checkPass: "",
      },
      formRules: {
        province: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
        school: [
          { required: true, message: "请选择所在班级", trigger: "change" },
        ],
        login_name: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        id_card: [{ required: true, message: "请输入账号", trigger: "blur" }],
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    // 省份切换
    provinceChange() {
      this.getCityList();
      this.city = "";
      this.county = "";
    },
    // 城市切换
    cityChange() {
      this.getCountList();
      this.county = "";
    },
    // 区县切换
    countyChange() {
      this.getSchoolList();
    },
    // 学校切换
    schoolChange() {
      this.getGradeList();
    },
    // 年级切换
    gradeChange() {
      this.getClassList();
    },
    // 班级切换
    classChange() {},
    // 获取省份列表
    getProvinceList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取省级数据错误, " + e.err);
          } else {
            if (e.rtnObj) {
              self.provinceList = e.rtnObj;
            } else {
              self.provinceList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        null,
        1
      );
    },
    // 获取城市
    getCityList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取城市数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.cityList = e.rtnObj;
            } else {
              self.cityList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        self.form.province,
        2
      );
    },
    // 获取区县
    getCountList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取区县数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.countyList = e.rtnObj;
            } else {
              self.countyList = [];
            }
          }
        },
        "SysMgrBiz.GetAreaListByParentIdNoToken",
        self.form.city,
        3
      );
    },
    // 获取学校
    getSchoolList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取学校数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.schoolList = e.rtnObj;
            } else {
              self.schoolList = [];
            }
          }
        },
        "SysMgrBiz.GetSchoolListByAreaIdNoToken",
        self.form.county
      );
    },
    // 获取年级
    getGradeList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取班级数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.gradeList = e.rtnObj;
            } else {
              self.gradeList = [];
            }
          }
        },
        "SysMgrBiz.GetGradeListBySchoolIdNoToken",
        self.form.school
      );
    },
    // 获取班级
    getClassList() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("获取班级数据错误, " + e.err);
          } else {
            if (e.rtnObj && e.rtnObj.length > 0) {
              self.classList = e.rtnObj;
            } else {
              self.classList = [];
            }
          }
        },
        "SysMgrBiz.GetClassByGradeIdNoToken",
        self.form.grade
      );
    },
    // 下一步
    next() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        // 判断是否为人员
        if (this.form.roleId == 1) {
          let self = this;
          LYCom.AsynCallBiz(
            function (e) {
              if (e.err) {
                self.$message.error("获取班级数据错误, " + e.err);
              } else {
                if (!e.rtnObj) {
                  self.$message.error(
                    "平台不存在该用户，请核实您输入的基本信息是否正确。"
                  );
                }
                self.isNext = e.rtnObj;
              }
            },
            "SysMgrBiz.ExistStudentAccount",
            self.form.class,
            self.form.id_card,
            self.form.login_name
          );
        } else {
          let self = this;
          LYCom.AsynCallBiz(
            function (e) {
              if (e.err) {
                self.$message.error("获取班级数据错误, " + e.err);
              } else {
                if (!e.rtnObj) {
                  self.$message.error(
                    "平台不存在该用户，请核实您输入的基本信息是否正确。"
                  );
                }
                self.isNext = e.rtnObj;
              }
            },
            "SysMgrBiz.ExistTeacherAccount",
            self.form.school,
            self.form.id_card,
            self.form.login_name
          );
        }
      });
    },
    // 提交
    submit() {
      let self = this;
      LYCom.AsynCallBiz(
        function (e) {
          if (e.err) {
            self.$message.error("重置错误, " + e.err);
          } else {
            if (e.rtnObj.success) {
              self
                .$confirm("是否跳转到登录界面？", "密码重置成功！")
                .then(() => {
                  self.$router.push({
                    name: "login",
                  });
                })
                .catch((_) => {});
            } else {
              self.$message.error("重置错误, " + e.err);
            }
          }
        },
        "SysMgrBiz.UpdatePwdNoToken",
        self.form.login_name,
        self.ruleForm.pass,
        self.ruleForm.checkPass
      );
    },
  },
};
</script>
 
<style scoped lang='less'>
.warp {
  width: 980px;
  margin: 0 auto;
}
.header {
  height: 70px;
  box-shadow: 0px 5px 15px #b3c6fc;
  color: white;
  background-image: url(/static/images/导航栏3.png);
  z-index: 99;
  position: relative;
}
.head_warp {
  display: flex;
  flex-direction: column;
  align-items: left;
  padding: 15px;
}
.head_title {
  font-size: 24px;
}
.content .warp {
  background: url(/static/images/container_bg.png) repeat-y;
  padding: 0 4px 0 100px;
}
.back-head {
  padding-top: 60px;
  line-height: 100%;
}
.back-head h3 {
  font-size: 20px;
  font-weight: 400;
}
.back-head p {
  margin: 15px 0 60px;
  font-size: 16px;
  color: #333;
}
/deep/ .el-radio__label {
  font-size: 20px;
  color: #000;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #091d7c;
}

.next {
  width: 780px;
  text-align: center;
}
.next_btn {
  padding: 12px 50px;
}
.area_list {
  display: flex;
  width: 675px;
}
.class_warp {
  width: 675px;
  display: flex;
}
.radio_warp {
  margin: 20px 0;
}
.area_list .el-select,
.class_warp .el-select {
  flex: 1;
}

.el-form-item {
  margin-bottom: 30px;
}

.rest_title {
  font-size: 20px;
  padding: 10px;
  height: 40px;
  line-height: 40px;
  width: 780px;
  margin: 20px 0;
}
.footer_line {
  height: 10px;
  background: linear-gradient(left, #000147, #1cb4df);
}
.footer {
  height: 60px;
  text-align: center;
  font-size: 13px;
  color: #999;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  a {
    font-size: 13px;
    color: #999999;
    text-decoration: none;
  }
}
.footer p {
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/components/forgetPassword.vue